import { render } from "./CSelectNaive.vue?vue&type=template&id=4758a53f"
import script from "./CSelectNaive.vue?vue&type=script&lang=js"
export * from "./CSelectNaive.vue?vue&type=script&lang=js"
script.render = render

export default script